import { findElement, onChangeElementVisibility, selectedElementAll } from "../utils/element-handlers.utils";
import $ from 'jquery';

const defaultClassName = 'n-default';
const activeClassName = 'n-active';

function TabsComponent(tabsElement: HTMLElement, urlHash: string) {
    var $tabsElement = $(tabsElement);
    var $tabListElement = $tabsElement.find('.n-tab-list');
    var $scrollBarScrollerElement = $tabsElement.find('.n-tab-list-scrollbar-scroller');
    var $scrollBarElement = $tabsElement.find('.n-tab-list-scrollbar');
    var $tabElements = $tabListElement.find('button.n-tab');
    var $contentElements = $tabsElement.find('.n-tab-contents > .n-tab-content');

    if ($tabElements.length && $contentElements.length) {
        startTabs($tabElements, $contentElements, urlHash);
    }

    if ($tabListElement[0] && $scrollBarElement[0] && $scrollBarScrollerElement[0]) {
        startScroll($tabListElement[0], $scrollBarElement[0], $scrollBarScrollerElement[0]);
    }
}

function startTabs(
    $tabElements: JQuery<HTMLElement>,
    $contentElements: JQuery<HTMLElement>,
    urlHash: string
) {
    $tabElements.each(function () {
        const $tabElement = $(this);
        const tabHash = $tabElement.attr('data-hash');
        const hasDefaultClass = $tabElement.hasClass(defaultClassName);
        const hasActiveClass = $tabElement.hasClass(activeClassName);
        const tabIsActive = urlHash && tabHash
            ? (urlHash === tabHash)
            : (hasActiveClass || hasDefaultClass);

        if (tabIsActive) {
            activateTab($tabElement.index(), !hasDefaultClass);
        }
        else if (hasActiveClass) {
            $tabElement.removeClass(activeClassName);
        }
    });

    $tabElements.on('click', function ($event) {
        $event.preventDefault();
        activateTab($(this).index(), true);
    });

    function activateTab(index: number, setHash: boolean) {
        $tabElements.removeClass(activeClassName);
        $contentElements.removeClass(activeClassName);

        const $tabElement = $($tabElements.get(index) as HTMLElement);
        const tabHash = $tabElement.attr('data-hash');
        $tabElement.addClass(activeClassName);
        $($contentElements.get(index) as HTMLElement).addClass(activeClassName);

        if (setHash && tabHash) {
            window.location.hash = tabHash;
        }
    }
}

function startScroll(
    tabListElement: HTMLElement,
    scrollbarElement: HTMLElement,
    scrollerElement: HTMLElement
) {
    const trackElement = findElement('.n-tab-track', tabListElement);
    let scrollerPositionX = 0;
    let currentDragPositionX: number | null = null;
    let dragging = false;
    let reverse = false;

    onChangeElementVisibility(scrollbarElement, function (isVisible) {
        if (isVisible) {
            updateScrollUI();
        }
    });

    tabListElement.addEventListener('wheel', function (event) {
        event.preventDefault();
        scrollerPositionX += event.deltaX;
        updateScrollUI();
    })

    window.addEventListener('resize', function () {
        updateScrollUI();
    });

    startTouchEvents();
    startMouseEvents();

    function updateScrollUI() {
        var hiddenAreaSizePx = tabListElement.scrollWidth - tabListElement.offsetWidth;
        var hiddenAreaSizePercentage = (hiddenAreaSizePx * 100) / tabListElement.scrollWidth;
        var scrollerWidthPercentage = 100 - hiddenAreaSizePercentage;
        var scrollerWidthPx = (scrollerWidthPercentage * scrollbarElement.offsetWidth) / 100;
        var maxScrollerMovementX = scrollbarElement.offsetWidth - scrollerWidthPx;
        var fixedScrollerPositionX = Math.max(0, Math.min(maxScrollerMovementX, scrollerPositionX));
        var trackPositionX = (hiddenAreaSizePx * fixedScrollerPositionX) / - maxScrollerMovementX;

        if (scrollerWidthPercentage >= 100) {
            scrollerElement.style.width = '100%';
            scrollerElement.style.left = '0px';
            if (trackElement) trackElement.style.transform = 'translateX(0px)';
            scrollerPositionX = 0;
            scrollbarElement.style.display = 'none';
        }
        else {
            scrollerElement.style.width = (scrollerWidthPx) + 'px';
            scrollerElement.style.left = fixedScrollerPositionX + 'px';
            if (trackElement) trackElement.style.transform = 'translateX(' + trackPositionX + 'px)';
            scrollerPositionX = fixedScrollerPositionX;
            scrollbarElement.style.display = 'block';
        }                
    }

    function startDrag(initialPositionX: number, isReverse: boolean) {
        if (!dragging) {
            dragging = true;
            currentDragPositionX = initialPositionX;
            reverse = Boolean(isReverse);
        }
    }

    function updateDrag(positionX: number) {
        if (dragging && (currentDragPositionX !== null)) {
            var dragDeltaX = (positionX - currentDragPositionX) * (reverse ? -1 : 1);
            scrollerPositionX += dragDeltaX;
            currentDragPositionX = positionX;
            updateScrollUI();
        }
    }

    function endDrag() {
        if (dragging) {
            dragging = false;
            currentDragPositionX = null;
            reverse = false;
        }
    }

    function startTouchEvents() {
        tabListElement.addEventListener('touchstart', function (event) {
            startDrag(event.touches[0].pageX, true);
        });

        tabListElement.addEventListener('touchmove', function (event) {
            event.preventDefault();
            updateDrag(event.touches[0].pageX);
        });

        tabListElement.addEventListener('touchend', function (event) {
            endDrag();
        });

        scrollerElement.addEventListener('touchstart', touchStartEvent);

        function touchStartEvent(event: TouchEvent) {
            startDrag(event.touches[0].pageX, false);
            scrollerElement.removeEventListener('touchstart', touchStartEvent);
            document.addEventListener('touchmove', touchMoveEvent);
            document.addEventListener('touchend', touchEndEvent);
        }

        function touchMoveEvent(event: TouchEvent) {
            if (dragging) {
                updateDrag(event.touches[0].pageX)
            }
        }
        
        function touchEndEvent(event: TouchEvent) {
            endDrag();
            scrollerElement.addEventListener('touchstart', touchStartEvent);
            document.removeEventListener('touchmove', touchMoveEvent);
            document.removeEventListener('touchend', touchEndEvent);
        }
    }

    function startMouseEvents() {
        scrollerElement.addEventListener('mousedown', mouseDownEvent);

        function mouseDownEvent(event: MouseEvent) {
            event.preventDefault();
            startDrag(event.pageX, false);
            scrollerElement.removeEventListener('mousedown', mouseDownEvent);
            document.addEventListener('mousemove', mouseMoveEvent);
            document.addEventListener('mouseup', mouseUpEvent);
            document.addEventListener('mouseleave', mouseUpEvent);
        }

        function mouseMoveEvent(event: MouseEvent) {
            if (dragging) {
                updateDrag(event.pageX);
            }
        }

        function mouseUpEvent(event: MouseEvent) {
            event.preventDefault();
            endDrag();
            scrollerElement.addEventListener('mousedown', mouseDownEvent);
            document.removeEventListener('mousemove', mouseMoveEvent);
            document.removeEventListener('mouseup', mouseUpEvent);
            document.removeEventListener('mouseleave', mouseUpEvent);
        }
    }
}

export default function initTabsComponent() {
    selectedElementAll('.n-tabs', tabsElement => {
        TabsComponent(tabsElement, window.location.hash);
    });
}
